import React from "react";
import { withRouter, useHistory, useLocation } from "react-router-dom";
import { useState, useEffect, Dimensions, useCallback } from "react";
import Button from "@mui/material/Button";
import axios from "axios";
import { MyUrl, LinkToBI, GoToBI, GoToMyDSP, GoToZviDSP } from "../../App";
import { Redirect, CallUrlsApi } from "../../App";
import queryString from "query-string";

var aa = 0;
var jwtToken = "";
export default function DashboardBody({ data2, name1, password1 }) {
  const items1 = localStorage.getItem("User");
  const [CheckTypeOfUser, setCheckTypeOfUser] = React.useState("");
  let history = useHistory();

  const ChckRefreshFunc = () => {
    console.log("11111111");
    var item2 = "";
    if (items1 === null) {
      const items = sessionStorage.getItem("User");
      item2 = items;
    } else {
      const items = localStorage.getItem("User");
      item2 = items;
    }
    var parsed = JSON.parse(item2);
    setCheckTypeOfUser(parsed.role);
    jwtToken = parsed.token;
    const base64Url = jwtToken.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(atob(base64));
    const expirationDate = new Date(payload.exp * 1000);
    const currentTime = new Date().getTime(); // Get the current time in milliseconds
    if (expirationDate < currentTime) {
      try {
        axios
          .post(
            `${MyUrl}/api/RefreshToken/refresh`,
            { accessToken: jwtToken },
            { withCredentials: true }
          )
          .then((response) => {
            parsed.token = response.data.accessToken;
            // Store the updated object back in sessionStorage
            const updatedObjString = JSON.stringify(parsed);
            if (items1 === null) {
              sessionStorage.setItem("User", updatedObjString);
            } else {
              localStorage.setItem("User", updatedObjString);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {}
    } else {
    }
  };
  useEffect(() => {
    ChckRefreshFunc();
  }, []);

  const { pathname } = useLocation();
  let [thecolor, setthecolor] = useState();
  const [thebutton, setthebutton] = useState("");

  function useWindowSize() {
    const [size, setSize] = useState([window.innerHeight, window.innerWidth]);
    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerHeight, window.innerWidth]);
      };
      window.addEventListener("resize", handleResize);
    }, []);
    return size;
  }
  const [height, width] = useWindowSize();
  useEffect(() => {
    window.scrollTo(0, 0);
    console.log(window.location.href);
  }, [pathname]);
  return (
    <div>
      <div
        style={{
          flex: 1,
          paddingTop: "8%",
          paddingRight: width > 766 ? "20%" : "",
          paddingLeft: width > 766 ? "20%" : "",
          //backgroundColor: "blue",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
            width: "100%",
            alignItems: "center",
          }}
        >
          <h5 style={{ fontSize: width > 766 ? "" : 10 }}>
            Good Morning, {name1}
          </h5>
          <h1 style={{ fontSize: width > 766 ? "" : 20 }}>Select Service</h1>
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
          }}
        >
          {Array.isArray(data2.responseData) ? (
            data2 &&
            data2.responseData.map((responseData) => (
              <div
                onMouseEnter={() => {
                  aa = responseData.id;
                  setthebutton(responseData.id);
                  setthecolor("green");
                  //  console.log(thebutton);
                }}
                onMouseLeave={() => {
                  aa = 0;
                  setthecolor("black");
                }}
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                  flex: width > 481 ? "0 1 25%" : "0 1 45%",
                  //  border: responseData.id === aa ? `1px solid black` : "",
                }}
              >
                {responseData.imageUrl !== "" ? (
                  <div
                    onClick={(e) => {
                      ChckRefreshFunc();
                      try {
                        console.log(responseData.name);
                        if (responseData.name === "MM") {
                          console.log("MM11");
                          const url = `${GoToBI}/?Authorization=Bearer ${jwtToken}`;
                          //const url = `http://localhost:3001/?Authorization=Bearer ${jwtToken}`;
                          window.open(url, "_blank");
                        } else if (responseData.name === "BI") {
                          console.log("BI11");
                          //const url = `${GoToBI}/?Authorization=Bearer ${jwtToken}`;
                          const url = `${GoToBI}/?Authorization=Bearer ${jwtToken}`;

                          window.open(url, "_blank");
                        } else if (responseData.name === "Soylent") {
                          const url = `${GoToZviDSP}/?jwt=${jwtToken}`;
                          window.open(url, "_blank");
                          const newWindow = window.open(url, "_blank");

                          if (newWindow) {
                            newWindow.focus();
                          }
                        } else {
                          // Construct the URL with the JWT token
                          const url = `${GoToMyDSP}?jwt=${jwtToken}`;
                          window.open(url, "_blank");
                          // Open the URL in a new browser tab or window
                          const newWindow = window.open(url, "_blank");
                          // Optionally, you can still push the URL to the history stack
                          // history.push(url);

                          // Focus on the new window (optional)
                          if (newWindow) {
                            newWindow.focus();
                          }
                          // const url = `http://localhost:3001/?jwt=${jwtToken}`; //`${GoToDSP}/?jwt=${jwtToken}`;
                          // window.open(url, "_blank");
                        }
                      } catch (error) {}
                    }}
                    style={{
                      margin: 5,
                      background: width < 768 ? "#f9f8f9" : "",
                      borderRadius: 20,
                      border:
                        responseData.id === aa
                          ? `1px solid #737373`
                          : "1px solid rgba(0, 0, 0, 0.0000005)",

                      //linear-gradient(to right,#d8ccf4, #ffff)"
                      cursor: "pointer",
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <img
                      src={require(`../../Images/${responseData.imageUrl}.png`)}
                      height="20%"
                      width="30%"
                      class="rounded"
                      alt="..."
                      style={{ margin: 25 }}
                    ></img>
                    <h4
                      style={{
                        // color: "#9333ea",
                        fontSize: "100%",
                        textAlign: "center",
                      }}
                    >
                      {responseData.name}
                    </h4>
                  </div>
                ) : (
                  <>
                    <Button variant="contained">{responseData.url}</Button>
                  </>
                )}

                <br></br>
              </div>
            ))
          ) : (
            <>
              <h5>You dont have any website!</h5>
              <div style={{ paddingTop: width > 1500 ? "15%" : "8%" }}></div>
            </>
          )}
        </div>
      </div>
      <div
        style={{
          flex: 1,
          paddingRight: "30%",
          backgroundColor: "red",
          height: "25%",
        }}
      ></div>
    </div>
  );
}
